<template>
    <div class="panel panel-default">
        <button class="btn btn-primary my-btn">
            <router-link to="./registration"
                >Edit My Details</router-link
            >
        </button>
        <div class="panel-heading">
            <h3 class="panel-title">My Details</h3>
        </div>
        <div class="panel-body">
            <table class="table">
                <tbody>
                    <tr>
                        <th>User Name</th>
                        <td>{{ client.user.username }}</td>
                    </tr>
                    <tr>
                        <th>Full Name</th>
                        <td>{{ client.full_titled_name }}</td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td>{{ client.email }}</td>
                    </tr>
                    <tr v-if="client.mobile">
                        <th>Mobile</th>
                        <td>{{ client.mobile }}</td>
                    </tr>
                    <tr>
                        <th>Job Title</th>
                        <td>{{ client.job_title }}</td>
                    </tr>
                    <tr v-if="client.company">
                        <th>Company</th>
                        <td>{{ client.company.name }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.panel-title {
    padding: 1rem;
    text-align: center;
}
</style>

<script>
export default {
    props: ["client"],
};
</script>
